export default __webpack_public_path__ + "static/media/responsibility4.0cf78da5.png";